export default __webpack_public_path__ + "static/media/contact_us.d0709220.svg";